import * as I from "immutable";

import { Action, actionCreators } from "../actions";
import { RoomMeta } from "../service/Data";

import { RootState } from ".";

type roomId = string;

export interface Store {
    metaByRoomId: I.Map<roomId, RoomMeta>;
}

export function initialStore(): Store {
    return {
        metaByRoomId: I.Map(),
    };
}

export function update(store = initialStore(), action: Action): Store {
    switch (action.type) {
        case actionCreators.onLogout.type:
        case actionCreators.onWrongToken.type: {
            return initialStore();
        }
        case actionCreators.onRoomMeta.type: {
            const { room_id: roomId, meta } = action.payload;
            const { metaByRoomId } = store;
            return { ...store, metaByRoomId: metaByRoomId.set(roomId, meta) };
        }
        default: {
            return store;
        }
    }
}

export type OuterStore = { roomMeta: Store };

function getMetaByRoomId(store: RootState) {
    return store.roomMeta.metaByRoomId;
}

export function getRoomMeta(store: RootState, roomId: string) {
    return getMetaByRoomId(store).get(roomId);
}
